
import { lazy } from "react";
import EmpShippingAddress from "./employee/screens/Orders/Shipping";
import EmpCustomers from "./employee/screens/Customers";
import EmpViewCustomer from "./employee/screens/Customers/ViewCustomer";
import EmpDataBase from "./employee/screens/Database";
import EmpEditFinishing from "./employee/screens/Database/EditFinishing";
import EmpEditQty from "./employee/screens/Database/EditQty";
import EmpEditMaterial from "./employee/screens/Database/EditMaterial";
import EmpAddQtyDatabase from "./employee/screens/Database/AddQty";
import EmpAddFinish from "./employee/screens/Database/AddFinish";
import EmpAddMaterial from "./employee/screens/Database/AddMaterial";
import EmpAddThickness from "./employee/screens/Database/AddThickness";
import EmployeRoute from "./middleware/Employe";
import AdminRoute from "./middleware/AdminRoute";
import QuotesDetailPay from "./screens/private/QuotesDetailPay";
import RfqDetail from "./screens/private/RfqDetail";
import NotAuthorized from "./employee/screens/NotAuthorized";
import FallbackPage from "./employee/screens/FallbackPage";
import NotFound from "./screens/private/NotFound";
import PrivateRoute from "./middleware/PrivateRoute";
import ScrollToTop from "./components/ScrollToTop";
import {
  Routes,
  Route,
  Outlet,
} from "react-router-dom";
import DxfAnalyzer from "./screens/private/dxfFile";
import MetalFinishing from "./screens/public/services/MetalFinishing";
import Products from "./screens/public/products";
import FAQForm from "./admin/screens/FAQ/AddEdit";
import FaqList from "./admin/screens/FAQ";
import ProductForm from "./admin/screens/Product/AddEdit";
import ProductList from "./admin/screens/Product";
import Offer from "./admin/screens/Offer";
import MaterialForm from "./admin/screens/Material";
import ViewMaterialPage from "./admin/screens/Material/ViewMaterial";

const AdminDashboard = lazy(() => import("./admin/screens/Dashboard"));
const AdminPaymentHistory = lazy(() => import("./admin/screens/Payments"));
const AdminReports = lazy(() => import("./admin/screens/Reports"));
const AdminViewPayment = lazy(() => import("./admin/screens/Payments/Viewpayment"));
const AdminEditProfile = lazy(() => import("./admin/screens/Editprofile"));
const AdminCut = lazy(() => import("./admin/screens/Cut"));
const AdminQueue = lazy(() => import("./admin/screens/Queue"));
const AdminOrders = lazy(() => import("./admin/screens/Orders"));
const AdminOrdersDetail = lazy(() => import("./admin/screens/Orders/Ordersdetail"));
const AdminQuotes = lazy(() => import("./admin/screens/Quotes"));
const AdminQuotesDetail = lazy(() => import("./admin/screens/Quotes/Quotesdetail"));
const AdminRFQS = lazy(() => import("./admin/screens/RFQS"));
const AdminRfqsDetail = lazy(() => import("./admin/screens/RFQS/Rfqsdetail"));
const EditRFQS = lazy(() => import("./admin/screens/Quotes/EditQuote"));
const ViewRFQS = lazy(() => import("./admin/screens/Quotes/viewRFQ"));
const CompleteOrders = lazy(() => import("./admin/screens/Orders/complete"));
const Employe = lazy(() => import("./admin/screens/Employe"));
const AddEmp = lazy(() => import("./admin/screens/Employe/AddEmp"));
const ShippingAddress = lazy(() => import("./admin/screens/Orders/Shipping"));
const Customers = lazy(() => import("./admin/screens/Customers"));
const ViewCustomer = lazy(() => import("./admin/screens/Customers/ViewCustomer"));
const DataBase = lazy(() => import("./admin/screens/Database"));
const EditFinishing = lazy(() => import("./admin/screens/Database/EditFinishing"));
const EditQty = lazy(() => import("./admin/screens/Database/EditQty"));
const EditMaterial = lazy(() => import("./admin/screens/Database/EditMaterial"));
const AddQtyDatabase = lazy(() => import("./admin/screens/Database/AddQty"));
const AddFinish = lazy(() => import("./admin/screens/Database/AddFinish"));
const AddMaterial = lazy(() => import("./admin/screens/Database/AddMaterial"));
const AddThickness = lazy(() => import("./admin/screens/Database/AddThickness"));
const AdminLayout = lazy(() => import("./admin/Layout"));



const EmpDashboard = lazy(() => import("./employee/screens/Dashboard"));
const EmpPaymentHistory = lazy(() => import("./employee/screens/Payments"));
const EmpViewPayment = lazy(() => import("./employee/screens/Payments/Viewpayment"));
const EmpEditProfile = lazy(() => import("./employee/screens/Editprofile"));
const EmpCut = lazy(() => import("./employee/screens/Cut"));
const EmpQueue = lazy(() => import("./employee/screens/Queue"));
const EmpOrders = lazy(() => import("./employee/screens/Orders"));
const EmpOrdersDetail = lazy(() => import("./employee/screens/Orders/Ordersdetail"));
const EmpQuotes = lazy(() => import("./employee/screens/Quotes"));
const EmpQuotesDetail = lazy(() => import("./employee/screens/Quotes/Quotesdetail"));
const EmpRFQS = lazy(() => import("./employee/screens/RFQS"));
const EmpRfqsDetail = lazy(() => import("./employee/screens/RFQS/Rfqsdetail"));
const EmpEditRFQS = lazy(() => import("./employee/screens/Quotes/EditQuote"));
const EmpViewRFQS = lazy(() => import("./employee/screens/Quotes/viewRFQ"));
const EmpCompleteOrders = lazy(() => import("./employee/screens/Orders/complete"));


// import EmpAdminLayout from "./employee/Layout";

// import EmpDashboard from "./employee/screens/Dashboard";
// import EmpPaymentHistory from "./employee/screens/Payments";
// import EmpViewPayment from "./employee/screens/Payments/Viewpayment";
// import EmpEditProfile from "./employee/screens/Editprofile";
// import EmpCut from "./employee/screens/Cut";
// import EmpQueue from "./employee/screens/Queue";
// import EmpOrders from "./employee/screens/Orders";
// import EmpOrdersDetail from "./employee/screens/Orders/Ordersdetail";
// import EmpQuotes from "./employee/screens/Quotes";
// import EmpQuotesDetail from "./employee/screens/Quotes/Quotesdetail";
// import EmpRFQS from "./employee/screens/RFQS";
// import EmpRfqsDetail from "./employee/screens/RFQS/Rfqsdetail";
// import EmpCompleteOrders from "./employee/screens/Orders/complete";
// import EmpDashboard from "./employee/screens/Dashboard";
// import EmpPaymentHistory from "./employee/screens/Payments";
// import EmpViewPayment from "./employee/screens/Payments/Viewpayment";
// import EmpEditProfile from "./employee/screens/Editprofile";
// import EmpCut from "./employee/screens/Cut";
// import EmpQueue from "./employee/screens/Queue";
// import EmpOrders from "./employee/screens/Orders";
// import EmpOrdersDetail from "./employee/screens/Orders/Ordersdetail";
// import EmpQuotes from "./employee/screens/Quotes";
// import EmpQuotesDetail from "./employee/screens/Quotes/Quotesdetail";
// import EmpRFQS from "./employee/screens/RFQS";
// import EmpRfqsDetail from "./employee/screens/RFQS/Rfqsdetail";


const Layouts = lazy(() => import("./employee/Layout"));
const Layout = lazy(() => import("./Layout"));
const Layout2 = lazy(() => import("./Layout2"));
const Layout3 = lazy(() => import("./Layout3"));
const Login = lazy(() => import("./auth/Login"));
const ForgotPassword = lazy(() => import("./auth/Forgotpassword"));
const OTP = lazy(() => import("./auth/OTP"));
const ResetPassword = lazy(() => import("./auth/Resetpassword"));
const SignUp = lazy(() => import("./auth/Signup"));
const Home = lazy(() => import("./screens/public/Home"));
const Aboutus = lazy(() => import("./screens/public/Aboutus"));
const Lasercutting = lazy(() => import("./screens/public/services/Lasercutting"));
const LaserCuttingGuidelines = lazy(() => import("./screens/public/resources/Lasercutting"));
const BendingGuidelines = lazy(() => import("./screens/public/resources/Bending"));
const Steel = lazy(() => import("./screens/public/resources/Steel"));
const Aluminum = lazy(() => import("./screens/public/resources/Aluminum"));
const StainlessSteel = lazy(() => import("./screens/public/resources/Stainlesssteel"));
const Brass = lazy(() => import("./screens/public/resources/Brass"));
const Specialty = lazy(() => import("./screens/public/resources/Specialty"));
const FAQ = lazy(() => import("./screens/public/resources/FAQ"));
const Shipping = lazy(() => import("./screens/public/resources/Shipping"));
const PaymentTerms = lazy(() => import("./screens/public/resources/Paymentterms"));
const PrivacyPolicy = lazy(() => import("./screens/public/resources/Privacypolicy"));
const RefundPolicy = lazy(() => import("./screens/public/resources/Refundpolicy"));
const TermsService = lazy(() => import("./screens/public/resources/Termsofservice"));
const Bending = lazy(() => import("./screens/public/services/Bending"));
const Orders = lazy(() => import("./screens/private/Orders"));
const RFQS = lazy(() => import("./screens/private/RFQS"));
const MyProfile = lazy(() => import("./screens/private/Profile"));
const MyAddresses = lazy(() => import("./screens/private/Addresses"));
const AddAddress = lazy(() => import("./screens/private/Addaddress"));
const EditAddress = lazy(() => import("./screens/private/Editaddress"));
const PaymentCards = lazy(() => import("./screens/private/Paymentcards"));
const OrdersDetail = lazy(() => import("./screens/private/Ordersdetail"));
const Quotes = lazy(() => import("./screens/private/Quotes"));
const QuotesDetail = lazy(() => import("./screens/private/Quotesdetail"));

const AdminCustomerRFQ = lazy(() => import("./admin/screens/Customers/rfq"));
const EmpCustomerRFQ = lazy(() => import("./employee/Customers/rfq"));

/**
 * Top-level router for public, customer, employee, and admin sections.
 *
 * The routes are grouped with shared layout shells and guard components:
 *
 * ## Admin console (`AdminRoute` + `AdminLayout`)
 * - `/admin/dashboard`: KPI overview for operations.
 * - `/admin/customers/rfq-detail`: Support view for inbound RFQs.
 * - `/admin/payment-history` & `/admin/payment-history/view-payment/:id`: Ledger and detail views.
 * - `/admin/edit-profile`: Admin profile management.
 * - `/admin/faq` and `/admin/faq/*`: CRUD for FAQ content.
 * - `/admin/products` and `/admin/products/*`: Product marketing content management.
 * - `/admin/banner/:id`: Promotional banner editor.
 * - `/admin/view-material` and `/admin/view-material/*`: Material catalog and editor.
 * - `/admin/archive`, `/admin/queue`, `/admin/orders`, `/admin/shipping-orders`, `/admin/complete-orders`: Order lifecycle management.
 * - `/admin/orders-detail/:id`: Detailed order drill-down.
 * - `/admin/employes`, `/admin/add/:id?`: Employee roster management.
 * - `/admin/customers`, `/admin/customers/:userid`: Customer account management.
 * - `/admin/quotes` and `/admin/quotes/*`: Quote lifecycle tooling.
 * - `/admin/rfqs` and `/admin/rfqs/*`: RFQ review and edit flows.
 * - `/admin/database/*`: Reference data administration (finishes, materials, quantities, thicknesses).
 *
 * ## Employee portal (`EmployeRoute` + `Layouts`)
 * - Mirrors many admin flows (dashboard, queue, orders, RFQs, database) but enforces granular permission keys.
 * - `/employee/not-authorized` provides a friendly fallback for rejected permissions.
 *
 * ## Auth & public marketing layouts
 * - `/login`, `/signup`, `/forgot-password`, `/otp`, `/reset-password`: Authentication entry points.
 * - `/`, `/about-us`, `/laser-cutting`, `/bending`, `/metalfinishing`, `/products`: Public marketing site wrapped by `Layout`.
 * - `/resources/*`: Documentation resources served inside `Layout2`.
 *
 * ## Authenticated customer experience (`PrivateRoute` + `Layout3`)
 * - `/orders`, `/orders/orders-detail/:id`: Order history and detail.
 * - `/rfqs`, `/rfq/rfq-detail/:id`: Customer RFQ management.
 * - `/my-profile`, `/my-addresses`, `/my-address/*`, `/payment-cards`: Account management flows.
 * - `/quotes`, `/quotes/*`, `/quotes/pay`: Quotes review and payment.
 * - `/filePath`: DXF analyzer tool.
 * - `*`: Fallback to the private `NotFound` screen.
 *
 * @param {{openPop?: boolean, handleClose?: Function, setSuccessMessage?: Function}} props
 * @returns {JSX.Element}
 */
export default function RoutesFile({openPop,handleClose,setSuccessMessage}) {
return (
<ScrollToTop>
  <Routes>
    <Route
      path="/admin/dashboard"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Dashboard"}>
              <AdminDashboard />
            </AdminLayout>
          }
        />
      }
    />

<Route
      path="/admin/customers/rfq-detail"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Request For Quote"}>
              <AdminCustomerRFQ />
            </AdminLayout>
          }
        />
      }
    />

    <Route
      path="/admin/payment-history"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Payment History"}>
              <AdminPaymentHistory />
            </AdminLayout>
          }
        />
      }
	></Route>
	<Route
      path="/admin/reports"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Reports"}>
              <AdminReports />
            </AdminLayout>
          }
        />
      }
    ></Route>
    <Route
      path="/admin/payment-history/view-payment/:id"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"View Payment"}>
              <AdminViewPayment />
            </AdminLayout>
          }
        />
      }
    ></Route>
    <Route
      path="/admin/edit-profile"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Edit Profile"}>
              <AdminEditProfile />
            </AdminLayout>
          }
        />
      }
    ></Route>
     <Route
      path="/admin/faq/add-faq"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"FAQ"}>
              <FAQForm />
            </AdminLayout>
          }
        />
      }
    ></Route>
     <Route
      path="/admin/faq/edit-faq/:id"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"FAQ"}>
              <FAQForm />
            </AdminLayout>
          }
        />
      }
    ></Route>
      <Route
      path="/admin/products/add-product"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Product"}>
              <ProductForm />
            </AdminLayout>
          }
        />
      }
    ></Route>
      <Route
      path="/admin/products"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Products"}>
              <ProductList />
            </AdminLayout>
          }
        />
      }
    ></Route>
       <Route
      path="/admin/banner/:id"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Banner"}>
              <Offer />
            </AdminLayout>
          }
        />
      }
    ></Route>
      <Route
      path="/admin/view-material/material-form"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Material Form"}>
              <MaterialForm />
            </AdminLayout>
          }
        />
      }
    ></Route>
        <Route
      path="/admin/view-material/:id"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Edit Material"}>
              <MaterialForm />
            </AdminLayout>
          }
        />
      }
    ></Route>
      <Route
      path="/admin/view-material"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Material"}>
              <ViewMaterialPage />
            </AdminLayout>
          }
        />
      }
    ></Route>
       <Route
      path="/admin/products/edit-product/:id"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Edit Product"}>
              <ProductForm isEditMode={true}  />
            </AdminLayout>
          }
        />
      }
    ></Route>
       <Route
      path="/admin/faq"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"FAQ"}>
              <FaqList />
            </AdminLayout>
          }
        />
      }
    ></Route>
    <Route
      path="/admin/archive"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Archive"}>
              <AdminCut />
            </AdminLayout>
          }
        />
      }
    ></Route>
    <Route
      path="/admin/queue"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Queue"}>
              <AdminQueue />
            </AdminLayout>
          }
        />
      }
    ></Route>
    <Route
      path="/admin/orders"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Orders"}>
              <AdminOrders />
            </AdminLayout>
          }
        />
      }
    ></Route>
    <Route
      path="/admin/complete-orders"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Complete Orders"}>
              <CompleteOrders />
            </AdminLayout>
          }
        />
      }
    ></Route>
    <Route
      path="/admin/shipping-orders"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Shipping Orders"}>
              <ShippingAddress />
            </AdminLayout>
          }
        />
      }
    ></Route>
    <Route
      path="/admin/orders-detail/:id"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Orders Detail"}>
              <AdminOrdersDetail />
            </AdminLayout>
          }
        />
      }
    ></Route>
    <Route
      path="/admin/employes"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Employee"}>
              <Employe />
            </AdminLayout>
          }
        />
      }
    ></Route>
    <Route
      path="/admin/customers"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Customers"}>
              <Customers />
            </AdminLayout>
          }
        />
      }
    ></Route>
    <Route
      path="/admin/customers/:userid"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"View Customer"}>
              <ViewCustomer />
            </AdminLayout>
          }
        />
      }
    ></Route>
    <Route
      path="/admin/add/:id?"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Add Employee"}>
              <AddEmp />
            </AdminLayout>
          }
        />
      }
    ></Route>

    <Route
      path="/admin/quotes"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Quotes"}>
              <AdminQuotes />
            </AdminLayout>
          }
        />
      }
    ></Route>
    <Route
      path="/admin/quotes/quotes-detail"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Quotes Detail"}>
              <AdminQuotesDetail />
            </AdminLayout>
          }
        />
      }
    ></Route>
    <Route
      path="/admin/rfqs"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"RFQ's"}>
              <AdminRFQS />
            </AdminLayout>
          }
        />
      }
    ></Route>

    <Route
      path="/admin/rfqs/edit-quote"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Edit Quote"}>
              <EditRFQS />
            </AdminLayout>
          }
        />
      }
    ></Route>
    <Route
      path="/admin/quotes/view-quote"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"View RFQ's"}>
              <ViewRFQS />
            </AdminLayout>
          }
        />
      }
    ></Route>
    <Route
      path="/admin/rfqs/rfqs-detail"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"RFQ's Detail"}>
              <AdminRfqsDetail />
            </AdminLayout>
          }
        />
      }
    ></Route>

    <Route
      path="/admin/database"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Database"}>
              <DataBase />
            </AdminLayout>
          }
        />
      }
    ></Route>

    <Route
      path="/admin/database/edit-finish/:id"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Edit Finishing"}>
              <EditFinishing />
            </AdminLayout>
          }
        />
      }
    ></Route>
    <Route
      path="/admin/database/add-finish"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Add Finishing"}>
              <AddFinish />
            </AdminLayout>
          }
        />
      }
    ></Route>
    <Route
      path="/admin/database/edit-material/:id"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Edit Material"}>
              <EditMaterial />
            </AdminLayout>
          }
        />
      }
    ></Route>
    <Route
      path="/admin/database/add-material"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Add Material"}>
              <AddMaterial />
            </AdminLayout>
          }
        />
      }
    ></Route>
    <Route
      path="/admin/database/add-thickness"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Add Thickness"}>
              <AddThickness />
            </AdminLayout>
          }
        />
      }
    ></Route>
    <Route
      path="/admin/database/edit-quantity/:id"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Edit Quantity"}>
              <EditQty />
            </AdminLayout>
          }
        />
      }
    ></Route>
    <Route
      path="/admin/database/add-quantity"
      element={
        <AdminRoute
          element={
            <AdminLayout title={"Add Quantity"}>
              <AddQtyDatabase />
            </AdminLayout>
          }
        />
      }
    ></Route>

    {/* Employee API's */}
    <Route
      path="/employee/dashboard"
      element={
        <EmployeRoute
          element={
            <Layouts title={"Dashboard"}>
              <EmpDashboard />
            </Layouts>
          }
          permissionKey="dashboard_permission"
        />
      }
    />

    <Route
      path="/employee/fallback-page"
      element={
        <Layouts title={"Welcome"}>
          <FallbackPage />
        </Layouts>
      }
    />
    <Route
      path="/employee/customers/rfq-detail"
      element={
        <EmployeRoute
          element={
            <Layouts title={"Request For Quote"}>
              <EmpCustomerRFQ /> 
            </Layouts>
          }
        />
      }
    />

    <Route
      path="/employee/payment-history"
      element={
        <EmployeRoute
          element={
            <Layouts title={"Payment History"}>
              <EmpPaymentHistory />
            </Layouts>
          }
        />
      }
    ></Route>
    <Route
      path="/employee/payment-history/view-payment/:id"
      element={
        <EmployeRoute
          element={
            <Layouts title={"View Payment"}>
              <EmpViewPayment />
            </Layouts>
          }
          permissionKey="payment_permission"
        />
      }
    ></Route>
    <Route
      path="/employee/edit-profile"
      element={
        <EmployeRoute
          element={
            <Layouts title={"Edit Profile"}>
              <EmpEditProfile />
            </Layouts>
          }
        />
      }
    ></Route>
    <Route
      path="/employee/archive"
      element={
        <EmployeRoute
          element={
            <Layouts title={"Archive"}>
              <EmpCut />
            </Layouts>
          }
          permissionKey="archive_permission"
        />
      }
    ></Route>
    <Route
      path="/employee/queue"
      element={
        <EmployeRoute
          element={
            <Layouts title={"Queue"}>
              <EmpQueue />
            </Layouts>
          }
          permissionKey="queue_permission"
        />
      }
    ></Route>
    <Route
      path="/employee/orders"
      element={
        <EmployeRoute
          element={
            <Layouts title={"Orders"}>
              <EmpOrders />
            </Layouts>
          }
          permissionKey="orders_permission"
        />
      }
    ></Route>

    <Route
      path="/employee/complete-orders"
      element={
        <EmployeRoute
          element={
            <Layouts title={"Complete Orders"}>
              <EmpCompleteOrders />
            </Layouts>
          }
          permissionKey="complete_order_permission"
        />
      }
    ></Route>
    <Route
      path="/employee/shipping-orders"
      element={
        <EmployeRoute
          element={
            <Layouts title={"Shipping Orders"}>
              <EmpShippingAddress />
            </Layouts>
          }
          permissionKey="shipping_order_permission"
        />
      }
    ></Route>
    <Route
      path="/employee/orders-detail/:id"
      element={
        <EmployeRoute
          element={
            <Layouts title={"Orders Detail"}>
              <EmpOrdersDetail />
            </Layouts>
          }
          permissionKey="orders_permission"
        />
      }
    ></Route>
    {/* <Route
    path="/employee/employes"
    element={
      <EmployeRoute
        element={
          <Layouts title={"Employee"}>
            <EmpEmploye />
          </Layouts>
        }
      />
    }
  ></Route> */}
    <Route
      path="/employee/customers"
      element={
        <EmployeRoute
          element={
            <Layouts title={"Customers"}>
              <EmpCustomers />
            </Layouts>
          }
          permissionKey="customer_permission"
        />
      }
    ></Route>
    <Route
      path="/employee/customers/:userid"
      element={
        <EmployeRoute
          element={
            <Layouts title={"View Customer"}>
              <EmpViewCustomer />
            </Layouts>
          }
          permissionKey="customer_permission"
        />
      }
    ></Route>
    {/* <Route
    path="/employee/add/:id?"
    element={
      <EmployeRoute
        element={
          <Layouts title={"Add Employee"}>
            <EmpAddEmp />
          </Layouts>
        }
      />
    }
  ></Route> */}

    <Route
      path="/employee/quotes"
      element={
        <EmployeRoute
          element={
            <Layouts title={"Quotes"}>
              <EmpQuotes />
            </Layouts>
          }
          permissionKey="quotes_permission"
        />
      }
    ></Route>
    <Route
      path="/employee/quotes/quotes-detail"
      element={
        <EmployeRoute
          element={
            <Layouts title={"Quotes Detail"}>
              <EmpQuotesDetail />
            </Layouts>
          }
          permissionKey="quotes_permission"
        />
      }
    ></Route>
    <Route
      path="/employee/rfqs"
      element={
        <EmployeRoute
          element={
            <Layouts title={"RFQ's"}>
              <EmpRFQS />
            </Layouts>
          }
          permissionKey="rfq_permission"
        />
      }
    ></Route>
    <Route
      path="/employee/not-authorized"
      element={
        <Layouts title={"Not Authorized"}>
          <NotAuthorized />
        </Layouts>
      }
    />
    <Route
      path="/employee/rfqs/edit-quote"
      element={
        <EmployeRoute
          element={
            <Layouts title={"Edit Quote"}>
              <EmpEditRFQS />
            </Layouts>
          }
          permissionKey="rfq_permission"
        />
      }
    ></Route>
    <Route
      path="/employee/quotes/view-quote"
      element={
        <EmployeRoute
          element={
            <Layouts title={"View RFQ's"}>
              <EmpViewRFQS />
            </Layouts>
          }
          permissionKey="rfq_permission"
        />
      }
    ></Route>
    <Route
      path="/employee/rfqs/rfqs-detail"
      element={
        <EmployeRoute
          element={
            <Layouts title={"RFQ's Detail"}>
              <EmpRfqsDetail />
            </Layouts>
          }
          permissionKey="rfq_permission"
        />
      }
    ></Route>

    <Route
      path="/employee/database"
      element={
        <EmployeRoute
          element={
            <Layouts title={"Database"}>
              <EmpDataBase />
            </Layouts>
          }
          permissionKey="database_permission"
        />
      }
    ></Route>

    <Route
      path="/employee/database/edit-finish/:id"
      element={
        <EmployeRoute
          element={
            <Layouts title={"Edit Finishing"}>
              <EmpEditFinishing />
            </Layouts>
          }
          permissionKey="database_permission"
        />
      }
    ></Route>
    <Route
      path="/employee/database/add-finish"
      element={
        <EmployeRoute
          element={
            <Layouts title={"Add Finishing"}>
              <EmpAddFinish />
            </Layouts>
          }
          permissionKey="database_permission"
        />
      }
    ></Route>
    <Route
      path="/employee/database/edit-material/:id"
      element={
        <EmployeRoute
          element={
            <Layouts title={"Edit Material"}>
              <EmpEditMaterial />
            </Layouts>
          }
          permissionKey="database_permission"
        />
      }
    ></Route>
    <Route
      path="/employee/database/add-material"
      element={
        <EmployeRoute
          element={
            <Layouts title={"Add Material"}>
              <EmpAddMaterial />
            </Layouts>
          }
          permissionKey="database_permission"
        />
      }
    ></Route>
    <Route
      path="/employee/database/add-thickness"
      element={
        <EmployeRoute
          element={
            <Layouts title={"Add Thickness"}>
              <EmpAddThickness />
            </Layouts>
          }
          permissionKey="database_permission"
        />
      }
    ></Route>
    <Route
      path="/employee/database/edit-quantity/:id"
      element={
        <EmployeRoute
          element={
            <Layouts title={"Edit Quantity"}>
              <EmpEditQty />
            </Layouts>
          }
          permissionKey="database_permission"
        />
      }
    ></Route>
    <Route
      path="/employee/database/add-quantity"
      element={
        <EmployeRoute
          element={
            <Layouts title={"Add Quantity"}>
              <EmpAddQtyDatabase />
            </Layouts>
          }
          permissionKey="database_permission"
        />
      }
    ></Route>

    {/* End Employee API's */}

    <Route exact path="/login" element={<Login />} />
    <Route path="/forgot-password" element={<ForgotPassword />} />
    <Route path="/otp" element={<OTP />} />
    <Route path="/reset-password" element={<ResetPassword />} />
    <Route path="/signup" element={<SignUp />} />
    <Route
      element={
        <Layout>
          <Outlet />
        </Layout>
      }
    >
      <Route path="/" element={<Home />} />
      <Route path="/about-us" element={<Aboutus />} />
      <Route path="/laser-cutting" element={<Lasercutting />} />
      <Route path="/bending" element={<Bending />} />
      <Route path="/metalfinishing" element={<MetalFinishing />} />
      <Route path="/products" element={<Products />} />
    </Route>
    <Route
      element={
        <Layout2>
          <Outlet />
        </Layout2>
      }
    >
      <Route
        path="/resources/laser-cutting"
        element={<LaserCuttingGuidelines />}
      />
      <Route path="/resources/bending" element={<BendingGuidelines />} />
      <Route path="/resources/steel" element={<Steel />} />
      <Route path="/resources/aluminum" element={<Aluminum />} />
      <Route path="/resources/stainless-steel" element={<StainlessSteel />} />
      <Route path="/resources/brass" element={<Brass />} />
      <Route path="/resources/specialty" element={<Specialty />} />
      <Route path="/resources/faq" element={<FAQ />} />
      <Route path="/resources/shipping" element={<Shipping />} />
      <Route path="/resources/payment-terms" element={<PaymentTerms />} />
      <Route path="/resources/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/resources/refund-policy" element={<RefundPolicy />} />
      <Route path="/resources/terms-service" element={<TermsService />} />
    </Route>
    <Route
      element={
        <Layout3>
          <Outlet />
        </Layout3>
      }
    >
      <Route path="/orders" element={<PrivateRoute element={<Orders />} />} />
      <Route path="/rfqs" element={<PrivateRoute element={<RFQS />} />} />
      <Route
        path="/orders/orders-detail/:id"
        element={<PrivateRoute element={<OrdersDetail />} />}
      />
      <Route
        path="/rfq/rfq-detail/:id"
        element={<PrivateRoute element={<RfqDetail />} />}
      />
      <Route
        path="/my-profile"
        element={<PrivateRoute element={<MyProfile />} />}
      />
      <Route
        path="/my-addresses"
        element={<PrivateRoute element={<MyAddresses />} />}
      />
      <Route
        path="/my-address/add-address"
        element={<PrivateRoute element={<AddAddress />} />}
      />
      <Route
        path="/my-address/edit-address/:id"
        element={<PrivateRoute element={<EditAddress />} />}
      />
      <Route path="/filePath" element={<DxfAnalyzer />} />
      <Route
        path="/payment-cards"
        element={<PrivateRoute element={<PaymentCards />} />}
      />
      <Route path="/quotes" element={<PrivateRoute element={<Quotes />} />} />
      <Route
        path="/quotes/quotes-detail"
        element={<PrivateRoute element={<QuotesDetail />} />}
      />
      <Route
        path="/quotes/pay"
        element={<PrivateRoute element={<QuotesDetailPay />} />}
      />
      <Route path="*" element={<NotFound />} />
    </Route>
  </Routes>
</ScrollToTop>
)
}
